type CommonColorType = 'light' | 'regular' | 'dark' | 'extraLight'
export type CommonColorPalette = 'brightBlue' | 'orange' | 'apple' | 'pink' | 'aubergine' | 'forest' | 'stone' | 'teal'
type CommonColor = Record<CommonColorType, Record<CommonColorPalette, string>>

export const commonColors: CommonColor = {
  extraLight: {
    apple: '#F3FBF5',
    aubergine: '#ece0eb',
    brightBlue: '#F4F8FE',
    forest: '#d7eeea',
    orange: '#FEF4F4',
    pink: '#FEF4F4',
    stone: '#e3eaee',
    teal: '#ddf4f4'
  },
  light: {
    apple: '#8FE1B1',
    aubergine: '#cfafcc',
    brightBlue: '#79B6FB',
    forest: '#a0d6cd',
    orange: '#F6C0A3',
    pink: '#F5BCC9',
    stone: '#b2c6d0',
    teal: '#a1e0e2'
  },
  regular: {
    apple: '#0CB43F',
    aubergine: '#721C7A',
    brightBlue: '#2870ED',
    forest: '#028661',
    orange: '#FF6130',
    pink: '#EB4C79',
    stone: '#245375',
    teal: '#02A3A4'
  },
  dark: {
    apple: '#017632',
    aubergine: '#401A48',
    brightBlue: '#064EA1',
    forest: '#014740',
    orange: '#D25200',
    pink: '#BC3B51',
    stone: '#023449',
    teal: '#036A6D'
  }
}

export const colors = {
  font: {
    dark: '#212121',
    darkFaded: '#506A97',
    link: '#2870ED',
    white: '#fff',
    disabled: '#9DAFC2',
    error: '#d53737',
    body: '#58646f',
    note: '#8C8F8F',
    standard: '#303030'
  },
  background: {
    white: '#fff',
    dark: '#0B1F42',
    grey: '#F4F6FA',
    greyMid: '#e4eaf0',
    greyDark: '#D4D5D6',
    disabled: '#d1dae4',
    greyDarker: '#A3B5C9'
  },
  icon: {
    dark: '#212121',
    active: '#2870ED',
    disabled: '#A3B5C9',
    white: '#fff'
  },
  input: {
    disabled: '#F8F9FB',
    border: '#C4C4C4',
    active: '#2870ED',
    white: '#fff'
  },
  common: commonColors
} as const
